import React, { useState } from 'react';
import Sidebar from './Sidebar.tsx';
import Header from './Header.tsx';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="app-shell">
      <Sidebar variant="desktop" />
      <Sidebar
        variant="drawer"
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <div className="main">
        <Header onMenuClick={() => setMobileOpen(true)} />
        <main className="content-area">{children}</main>
      </div>
    </div>
  );
};

export default Layout;
